import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';

const monitorOrderAPI = (data, success) => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/sale/monitor_order/ `,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    success();
  }).catch(err => {
    if (err.data) {
      alert(JSON.stringify(err.data))
    } else {
      alert(JSON.stringify(err));
    }
  });
}

const modalStyle = {
  width: '500px',
  height: '160px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class MonitorNote extends Component {
  state = {
    note: '',
  }

  handleConfirmClick = () => {
    const data = {
      SalesOrderId: this.props.monitorRow.SalesOrder_id,
      Notation: this.state.note,
    }
    const success = () => {
      this.props.handleMonitorOrderSuccess();
    }
    monitorOrderAPI(data, success);
  }

  render() {
    return (
      <form style={styles.container}>
        {/* <h4>Location Change</h4> */}
        <div>
          <input
            type="text"
            style={{
              width: '300px',
              border: '1px solid black',
              padding: '2px',
              borderRadius: '5px',
              marginBottom: '10px',
            }}
            onChange={({ target }) => this.setState({
              note: target.value,
            })}
            value={this.state.note}
          />
        </div>
        <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          onClick={() => {
            this.handleConfirmClick();
          }}
        >
          <Translate value="confirm" />
        </Button>
      </form>
    )
  }
}

const MonitorNoteModal = ({ isVisible, setModalVisibility, monitorRow, handleMonitorOrderSuccess }) => (
  <SkyLightStateless
    title={'Monitor Order Note'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <MonitorNote setModalVisibility={setModalVisibility} monitorRow={monitorRow} handleMonitorOrderSuccess={handleMonitorOrderSuccess} />
  </SkyLightStateless>
)

MonitorNoteModal.propTypes = propTypes
MonitorNoteModal.defaultProps = defaultProps

export default MonitorNoteModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/MonitorNoteModal.jsx